const notestype = {
	name: 'Notizart | Notizarten',
	fields: {
		name: 'Bezeichnung',
		color_header: 'Farbe',
	},
}

export default notestype
